export const comments_4504523 = {"data":{"data":[],"links":{}}}